import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0213',
    ecrans: ['00-2'],
    params: ['mobcleintref',
             'stamnetab']
});
